module.exports = __webpack_public_path__ + "img/electric-meter.641cf95c.png";